import { render, staticRenderFns } from "./addPrescriptionContact.vue?vue&type=template&id=24d871e3"
import script from "./addPrescriptionContact.vue?vue&type=script&lang=js"
export * from "./addPrescriptionContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports